import React from 'react';
import { Tooltip } from '@mui/material';
import { SettingsIcon } from '../../svg/TemplateIcons';

const TemplateDashboardTabItem = ({
    wd,
    idx,
    edit,
    isActive,
    canReorderDashboardTabs,
    dragLabel,
    editRolesLabel,
    onSelect,
    onOpenSettings,
}) => (
    <Tooltip
        key={wd.id || idx}
        title={edit.mode === 'edit' && canReorderDashboardTabs ? dragLabel : ''}
        disableInteractive
        PopperProps={{ disablePortal: true }}
    >
        <div
            className={`dashboard-tab ${isActive ? 'active' : ''}`}
            draggable={false}
            data-original-index={idx}
            title={wd.name}
            style={{
                textAlign: 'center',
                fontSize: 'calc(var(--ui-font-size) * var(--font-size-multiplier))',
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '5px',
            }}
            onClick={onSelect}
        >
            <span style={{ pointerEvents: 'none' }}>{wd.name}</span>

            {edit.mode === 'edit' && canReorderDashboardTabs && (
                <span
                    className="dashboard-tab-drag-handle"
                    draggable
                    onMouseDown={(e) => {
                        e.stopPropagation();
                    }}
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                    onDragStart={(e) => {
                        e.stopPropagation();
                        e.dataTransfer.effectAllowed = 'move';
                        e.dataTransfer.setData('text/plain', idx.toString());
                    }}
                    aria-label={dragLabel || 'Drag to reorder tab'}
                    title={dragLabel || 'Drag to reorder tab'}
                    role="button"
                >
                    ::
                </span>
            )}

            {edit.mode === 'edit' && (
                <button
                    type="button"
                    className="settings-btn dashboard-tab-settings-btn"
                    onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onOpenSettings(e);
                    }}
                    style={{
                        all: 'unset',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        color: 'var(--primary)',
                        padding: '2px',
                        borderRadius: '6px',
                    }}
                    aria-label={editRolesLabel || 'Edit dashboard roles'}
                >
                    <SettingsIcon
                        style={{
                            fontSize:
                                'calc(var(--ui-font-size) * var(--font-size-multiplier) * 0.8)',
                        }}
                    />
                </button>
            )}
        </div>
    </Tooltip>
);

export default TemplateDashboardTabItem;
